import * as React from 'react';

import {
    Stack,
    List,
    ListItemButton,
    ListItemIcon,
    ListSubheader,
    Box,
    Avatar,
    ListItem,
    useMediaQuery
} from '@mui/material'
import { Logout } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import WhatsAppIcon from '@mui/icons-material/WhatsApp';

import Background2 from '../../../../assets/images/background/Move_foto.jpg';
import Background3 from '../../../../assets/images/background/onibus.jpg';

import Icon from '../../../../assets/images/icons/icones-13-150x150.png';
import Icon2 from '../../../../assets/images/icons/icones-14-150x150.png';
import Icon3 from '../../../../assets/images/icons/icones-12-150x150.png';

import logo from '../../../../assets/images/logo/msite-300x128.png';
import logo2 from '../../../../assets/images/logo/msite-4.png';
import logo3 from '../../../../assets/images/logo/msite-2.png';
import logo4 from '../../../../assets/images/logo/msite-5.png';

import redesocial from '../../../../assets/images/logo/redes_sociais/icones-1-pfvc3qm8241i7sbhtabrpckt5gn2e7d3h91e23eyr8.png';
import redesocial2 from '../../../../assets/images/logo/redes_sociais/icones-4-pfvc3udktg6ni8617by9zbmnj04j8zs0trnbz79e2c.png';
import redesocial3 from '../../../../assets/images/logo/redes_sociais/icones-3-pfvc3tfqmm5d6m7ectjnetv6xm961aoahmzuhxas8k.png';
import redesocial4 from '../../../../assets/images/logo/redes_sociais/icones-2-pfvc3rk28y2sjea4nsqe9uc9quiflwgttdovjddkl0.png';
import redesocial5 from '../../../../assets/images/logo/redes_sociais/icones-5-pfvc3oqjofyxkke849iikd1vyowbyt5mszqf3jhr3o.png';
import LinkedInIcon from '@mui/icons-material/LinkedIn';

import PaymentsIcon from '@mui/icons-material/Payments';
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import DirectionsBusIcon from '@mui/icons-material/DirectionsBus';


import { BaseComp, BaseContent, TextBody, TextContent, TextTitle, DefaultBox, ImageContent, Img, ImageBox, SidebySideContent, ContactConsultant, OurMission, MiddleContent, IconImg, SocialImg, StyledLink, AboutUs, Frota, FrotaContent, PrincipalDiv, Partners, SocialMedia } from './styles';
import { Banner } from './Banner';
import News from './News';
import HistoryCarrousel from './HistoryCarrousel';

interface INavBar {

}



const MainContent: React.FC<INavBar> = () => {
    const navigate = useNavigate();

    const matches = useMediaQuery('(max-width:800px)');

    const Whatsap = 'https://api.whatsapp.com/send/?phone=5531982213102&text&type=phone_number&app_absent=0';
    const Linkedin = 'https://br.linkedin.com/company/gomidiabh';
    const Instagram = 'https://www.instagram.com/gomidiabh/';



    return (
        <BaseComp id='main'>
            <BaseContent>
                <Banner/>
                <TextContent>
                    <AboutUs id='us'>
                        <TextBody>
                            <TextTitle>
                                <h1>Quem Somos</h1>
                            </TextTitle>
                            <p>
                                O SetraBH é o Sindicato das Empresas de Transporte de Passageiros de Belo Horizonte, com uma longa trajetória de compromisso com a mobilidade urbana, promovendo qualidade, segurança e eficiência no transporte coletivo.

                            </p>
                        </TextBody>
                    </AboutUs>
                    <TextBody id='ourhistory'>
                        <TextTitle>
                            <h1>Nossa História</h1>
                        </TextTitle>
                        <p>
                            Criado em 1952, o Sindicato das Empresas de Transporte de Passageiros nasceu como Setransp. Na época eram poucas as empresas, já que a maioria dos ônibus era de propriedade individual e alguns veículos pertenciam à Prefeitura.
                        </p>
                        <p>
                            Com o sindicato, começou também a organização e a modernização do transporte de passageiros da Capital e Região Metropolitana de Belo Horizonte, ao lado da criação de órgãos gestores como Departamento Municipal de Transportes, Metrobel, Transmetro e, atualmente, a BHTrans.

                        </p>
                        <p>
                            Em 2001, pensando em aprimorar ainda mais a qualidade do serviço prestado aos belo-horizontinos, o Setransp deu lugar ao SetraBH (Sindicato das Empresas de Transporte de Passageiros de Belo Horizonte) e ao Sintram (Sindicato das Empresas de Transporte de Passageiros Metropolitano).

                        </p>
                    </TextBody>
                    <OurMission id="ourmission">
                        <TextBody>
                            <TextTitle>
                                <h1>Nossa Missão</h1>
                            </TextTitle>
                            <p>
                                Participar ativamente da vida do belo-horizontino, oferecendo um serviço de transporte coletivo de qualidade para seus deslocamentos diários, com conforto e segurança.
                            </p>
                        </TextBody>
                        <HistoryCarrousel />
                    </OurMission>
                    <Frota id="fleet">
                        <TextTitle className='operation'>
                            <h2>Operação e Frota</h2>
                        </TextTitle>
                        <FrotaContent>
                            <MiddleContent>
                                <PaymentsIcon style={{ color:'var(--light-setra-blue)'}} className='icons'/>
                                <h1>R$ 274 Milhões</h1>
                                <h2>Passageiros catracados em 2024</h2>
                            </MiddleContent>
                            <MiddleContent>
                                <CorporateFareIcon style={{ color:'var(--light-setra-blue)'}} className='icons'/>
                                <h1>33</h1>
                                <h2>Empresas</h2>
                            </MiddleContent>
                            <MiddleContent>
                                <DirectionsBusIcon style={{ color:'var(--light-setra-blue)'}} className='icons'/>
                                <h1>+ 2600</h1>
                                <h2>Ônibus</h2>
                            </MiddleContent>
                        </FrotaContent>
                    </Frota>
                    <News />
                    <PrincipalDiv>
                        <Partners>
                            <TextTitle className='parceiro'>
                                <h2>Parceiros</h2>
                            </TextTitle>
                            <MiddleContent>
                                <StyledLink href='https://www.transfacil.com.br/' target='_blank'>
                                    <IconImg src={logo} />
                                </StyledLink>
                                <StyledLink href='https://www.cnt.org.br/' target='_blank'>
                                    <IconImg src={logo2} />
                                </StyledLink>
                                <StyledLink href='https://www.cnt.org.br/' target='_blank'>
                                    <IconImg src={logo3} />
                                </StyledLink>
                                <StyledLink href='https://www.bhtrans.pbh.gov.br/' target='_blank'>
                                    <IconImg src={logo4} />
                                </StyledLink>
                            </MiddleContent>
                        </Partners>
                        <SocialMedia>
                            <TextTitle className='redes'>
                                <h2>Redes Sociais</h2>
                            </TextTitle>
                            <MiddleContent className='rede'>
                                <StyledLink href='https://www.instagram.com/setrabh/' target='_blank'>
                                    <SocialImg src={redesocial} />
                                </StyledLink>
                                <h1>@setrabh</h1>
                                <StyledLink href='https://www.facebook.com/setrabh' target='_blank'>
                                    <SocialImg src={redesocial4} />
                                </StyledLink>
                                <h1>@setrabh</h1>
                                <StyledLink href='https://www.youtube.com/@SetraBH' target='_blank'>
                                    <SocialImg src={redesocial5} />
                                </StyledLink>
                                <h1>@setrabh</h1>
                                <StyledLink href='https://www.linkedin.com/company/setra-bh-oficial/?viewAsMember=true' target='_blank'>
                                    <LinkedInIcon  style={{ color:'var(--soft-setra-blue)', height:"60px", width:"60px"}} className='socialIcon' />
                                </StyledLink>
                                <h1>@setrabh</h1>
                            </MiddleContent>
                        </SocialMedia>
                    </PrincipalDiv>
                </TextContent>
            </BaseContent>
        </BaseComp>
    );
}

export { MainContent }